/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas_last_edit/:workflow_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasLastEditWorkflowId } from "./constants";
import type { GetCanvasLastEditResult } from "./types";
import { isGetCanvasLastEditResult } from "./validators";

export const getCanvasLastEdit = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasLastEditWorkflowId,
  (signal: AbortSignal, workflowId: string, appGroupId: string): Promise<GetCanvasLastEditResult> => {
    return fetch(
      `/engagement/${appGroupId}/canvas_last_edit/${workflowId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCanvasLastEditResult
);
